import Vue from "vue";
import { getImageUrl } from "@/utils/imageUrl";

Vue.prototype.$imageUrl = getImageUrl;
Vue.filter("imageUrl", getImageUrl);
